import React, { useEffect, useState } from 'react'; 
import Sidebar from './Sidebar';  
import styles from './../../Assets/CSS/Style.module.css';
import './../../Assets/CSS/Video.css';
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import Info from './Info';
 
function Video() {
    const accessToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);
    const [video, setVideo] = useState([]);
    
    useEffect(() => {
        document.title = 'Infomart | User Video';
        setIsLoading(true);
        axios.get(`${BASE_URL}/user/video`, {
            headers: { 
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setVideo(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    }, []);
    
    const [currentPage, setCurrentPage] = useState(1);
    const videosPerPage = 4;
    const totalPages = Math.ceil(video.length / videosPerPage);
    
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    
    const startIndex = (currentPage - 1) * videosPerPage;
    const currentVideos = video.slice(startIndex, startIndex + videosPerPage);
    
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5>
                    :
                        <div className={styles.trainingVideosContainer}>
                            <div className={styles.trainingVideosLeft}>
                                {video.length > 0 ? (
                                    <>
                                        <div className="videos-container">
                                            {currentVideos.map((video, i) => {
                                                const videoId = new URL(video.link).searchParams.get('v');
                                                const embedUrl = videoId ? `https://www.youtube.com/embed/${videoId}` : video.link;
                                                return (
                                                    <div className="video-card" key={i}>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                                            <h3 style={{ margin: 0 }}>{video.title}</h3>
                                                            <span style={{ 
                                                                backgroundColor: '#125fdc', 
                                                                color: 'white', 
                                                                padding: '4px 12px', 
                                                                borderRadius: '4px', 
                                                                fontSize: '12px',
                                                                fontWeight: 'bold'
                                                            }}>
                                                                {video.video_category?.name || 'No Category'}
                                                            </span>
                                                        </div>
                                                        <iframe 
                                                            width="100%" 
                                                            height="180" 
                                                            src={embedUrl} 
                                                            title={video.title} 
                                                            frameBorder="0" 
                                                            allowFullScreen
                                                        ></iframe>
                                                        <p className="mb-0">{video.sub_title}</p> 
                                                        <p className="date-added">
                                                            <b>Added On:</b> {new Date(video.created_at).toLocaleDateString()}
                                                        </p>
                                                    </div> 
                                                );
                                            })}
                                        </div>
                                        <div className="pagination">
                                            <button onClick={handlePreviousPage} disabled={currentPage === 1}>Previous</button>
                                            <span>Page {currentPage} of {totalPages}</span>
                                            <button onClick={handleNextPage} disabled={currentPage === totalPages}>Next</button>
                                        </div>
                                    </>
                                ) : (
                                    <p className="mx-auto text-danger fw-bold mt-5">No videos found.</p>
                                )}
                            </div>
                        </div>
                    }
                </div>
            </div> 
        </div>
    );
}

export default Video; 